/** Ant Design Modal из карточки клиента: выше .record-visit-client-modal-front .sport-modal-overlay (1100) */
export const CLIENT_NESTED_ANTD_MODAL_Z_INDEX = 1200;
